import SLS_pedidosVendas from '@/api/Operacoes/sls_pedidosVendas';
import Notifier from '@/libs/Notifier';

export default {
  namespaced: true,
  state: () => ({
    setIsLoading: false,
    setIsLoadinglistarCapaPedido: false,
    setIsLoadinglistarEntregaPedido: false,
    setIsLoadinglistarItensPedido: false,
    setIsLoadingSalvarItens: false,
    setIsLoadingCancelarPedido: false,
    setPedidoVendas: [],
    setCapaPedido: {},
    setItensPedido: [],
    setEnderecoEntrega: {},
    filters: {},
    meta: {},
  }),
  actions: {
    async retornaPedidoVendas({ commit, state }) {
      try {
        commit('SET_IS_LOADING', true);

        const params = { ...state.filters };

        try {
          const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado'));

          if (perfilLogado) {
            if (perfilLogado.perfil_acesso_nome === 'Representante') {
              const representanteData = JSON.parse(localStorage.getItem('representanteData'));
              if (representanteData && representanteData.representanteid) {
                params.perfilTipo = 'Representante';
                params.perfilId = representanteData.representanteid;
              }
            } else if (perfilLogado.perfil_acesso_nome === 'ClienteFinal') {
              const clienteData = JSON.parse(localStorage.getItem('clienteData'));
              if (clienteData && clienteData.clienteid) {
                params.perfilTipo = 'ClienteFinal';
                params.perfilId = clienteData.clienteid;
              }
            }
          }
        } catch (error) {
          console.error('Erro ao obter informações de perfil:', error);
        }

        const { data, meta } = await new SLS_pedidosVendas().getPedidosVendas(params);
        commit('SET_PEDIDO_VENDAS', data);
        commit('SET_META', meta);
      } catch (error) {
        throw this.notify.error(error.message);
      } finally {
        commit('SET_IS_LOADING', false);
      }
    },
    async retornaRascunhosPedidoVendas({ commit, state }) {
      try {
        commit('SET_IS_LOADING', true);

        const params = { ...state.filters };

        try {
          const perfilLogado = JSON.parse(localStorage.getItem('perfilLogado'));

          if (perfilLogado) {
            if (perfilLogado.perfil_acesso_nome === 'Representante') {
              const representanteData = JSON.parse(localStorage.getItem('representanteData'));
              if (representanteData && representanteData.representanteid) {
                params.perfilTipo = 'Representante';
                params.perfilId = representanteData.representanteid;
              }
            } else if (perfilLogado.perfil_acesso_nome === 'ClienteFinal') {
              params.perfilTipo = 'ClienteFinal';
              const clienteData = JSON.parse(localStorage.getItem('clienteData'));
              if (clienteData && clienteData.clienteid) {
                params.perfilId = clienteData.clienteid;
              }
            }
          }
        } catch (error) {
          console.error('Erro ao obter informações de perfil:', error);
        }

        const { data, meta } = await new SLS_pedidosVendas().getRascunhosPedidosVendas(params);
        commit('SET_PEDIDO_VENDAS', data);
        commit('SET_META', meta);
      } catch (error) {
        throw this.notify.error(error.message);
      } finally {
        commit('SET_IS_LOADING', false);
      }
    },
    async cancelarPedido({ commit, state }, pedidoid) {
      try {
        commit('SET_IS_LOADING_CANCELAR_PEDIDO', true);
        await new SLS_pedidosVendas().cancelarPedido(pedidoid);
      } catch (error) {
        throw this.notify.error(error.message);
      } finally {
        commit('SET_IS_LOADING_CANCELAR_PEDIDO', false);
      }
    },
    async listarCapaPedido({ commit, state }, pedidoid) {
      try {
        commit('SET_IS_LOADING_CAPA_PEDIDO_VENDA', true);
        const { data } = await new SLS_pedidosVendas().listarCapaPedido(pedidoid);
        commit('SET_CAPA_PEDIDO', data);
      } catch (error) {
        throw this.notify.error(error.message);
      } finally {
        commit('SET_IS_LOADING_CAPA_PEDIDO_VENDA', false);
      }
    },
    async salvarItensNovos({ commit, state }, data) {
      try {
        commit('SET_IS_LOADING_SALVAR_ITENS', true);
        await new SLS_pedidosVendas().salvarItens(data);
      } catch (error) {
        throw this.notify.error(error.message);
      } finally {
        commit('SET_IS_LOADING_SALVAR_ITENS', false);
      }
    },
    async enderecoEntregaPedido({ commit, state }, clienteid) {
      try {
        commit('SET_IS_LOADING_ENTREGA_PEDIDO', true);
        const { data } = await new SLS_pedidosVendas().enderecoEntregaPedido(clienteid);
        commit('SET_ENDERECO_ENTREGA', data);
      } catch (error) {
        throw this.notify.error(error.message);
      } finally {
        commit('SET_IS_LOADING_ENTREGA_PEDIDO', false);
      }
    },
    async retornaItensPedido({ commit }, pedidoid) {
      try {
        commit('SET_IS_LOADING_ITENS_PEDIDO', true);
        const { dataItens } = await new SLS_pedidosVendas().itensPedido(pedidoid);

        // Mapear os itens para incluir os campos de impostos
        const itensComImpostos = dataItens.map((item) => ({
          ...item,
          PrecoComImposto: parseFloat(item.PrecoComImposto || 0),
          BaseIcms: parseFloat(item.BaseIcms || 0),
          ValorIcms: parseFloat(item.ValorIcms || 0),
          valorTotalComImposto: item.itens.reduce((acc, subItem) => acc + ((subItem.precoComImposto || 0) * subItem.pedidoItemQuantidade), 0),
          itens: item.itens.map((subItem) => ({
            ...subItem,
            precoComImposto: parseFloat(subItem.precoComImposto || 0),
            baseIcms: parseFloat(subItem.baseIcms || 0),
            valorIcms: parseFloat(subItem.valorIcms || 0),
            valorTotalComImposto: parseFloat(subItem.precoComImposto || 0) * subItem.pedidoItemQuantidade,
          })),
        }));

        commit('SET_ITENS_PEDIDO', itensComImpostos);
      } catch (error) {
        throw this.notify.error(error.message);
      } finally {
        commit('SET_IS_LOADING_ITENS_PEDIDO', false);
      }
    },
    async setFilters({ commit }, filters) {
      commit('SET_FILTERS', filters);
    },
    async clearFilters({ commit }) {
      commit('clearFilters');
    },
    async setItensPedido({ commit, state }, data) {
      commit('SET_ITENS_PEDIDO', data);
    },
    async setItensTabelaPedido({ commit, state }, data) {
      commit('SET_ITENS_TABELA_PEDIDO', data);
    },
  },
  mutations: {
    SET_IS_LOADING(state, data) {
      state.setIsLoading = data;
    },
    SET_IS_LOADING_CANCELAR_PEDIDO(state, data) {
      state.setIsLoadingCancelarPedido = data;
    },
    SET_IS_LOADING_CAPA_PEDIDO_VENDA(state, data) {
      state.setIsLoadinglistarCapaPedido = data;
    },
    SET_IS_LOADING_SALVAR_ITENS(state, data) {
      state.setIsLoadingSalvarItens = data;
    },
    SET_IS_LOADING_ENTREGA_PEDIDO(state, data) {
      state.setIsLoadinglistarEntregaPedido = data;
    },
    SET_IS_LOADING_ITENS_PEDIDO(state, data) {
      state.setIsLoadinglistarItensPedido = data;
    },
    SET_PEDIDO_VENDAS(state, data) {
      state.setPedidoVendas = data;
    },
    // SET_FILTERS(state, data) {
    //     console.log('SET_FILTERS', data)
    //     state.filters = data;
    //     console.log("Updated Filters:", state.filters);
    // },
    SET_FILTERS(state, data) {
      const next = { ...state.filters };
      Object.entries(data || {}).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') {
          delete next[key];
          return;
        }
        if (typeof value === 'number' && isNaN(value)) {
          delete next[key];
          return;
        }
        next[key] = value;
      });
      state.filters = next;
    },
    clearFilters(state) {
      state.filters = {};
    },
    SET_META(state, data) {
      state.meta = data;
    },
    SET_CAPA_PEDIDO(state, data) {
      state.setCapaPedido = data;
    },
    SET_ITENS_PEDIDO(state, data) {
      state.setItensPedido = data;
    },
    SET_ITENS_TABELA_PEDIDO(state, data) {
      const exist = state.setItensPedido.find((item) => item.referencia === data.referencia);

      if (exist) {
        exist.Qtde += data.Qtde;
        exist.ValorTotal += data.ValorTotal;

        data.itens.forEach((novoItem) => {
          const existVariacao = exist.itens.find((item) => item.cdncor === novoItem.cdncor && item.desc_tamanho === novoItem.desc_tamanho);
          if (existVariacao) {
            existVariacao.pedidoItemQuantidade += novoItem.pedidoItemQuantidade;
            existVariacao.valorTotal += novoItem.valorTotal;
          } else {
            exist.itens.push(novoItem);
          }
        });
      } else {
        state.setItensPedido.push(data);
      }
    },
    SET_ENDERECO_ENTREGA(state, data) {
      state.setEnderecoEntrega = data;
    },
  },
  getters: {
    getIsLoading: (state) => state.setIsLoading,
    getPedidoVendas: (state) => state.setPedidoVendas,
    getFilters: (state) => state.filters,
    getMeta: (state) => state.meta,
    getCapaPedido: (state) => state.setCapaPedido,
    getItensPedido: (state) => state.setItensPedido,
    getEnderecoEntrega: (state) => state.setEnderecoEntrega,
  },
};
